import styled, { css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'

import { getBasePath } from '../../../utils/miscellaneous-utils'

export const OuterSection = styled.section`
    width: 100%;
    padding: 1rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 1rem 1.5rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        flex-direction: row;
        padding: 2rem 1.5rem 1rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        padding: 2rem 4rem 1rem;
    }
`

export const InnerContainer = styled.div``

export const InnerSection = styled.div`
    margin: 0 auto;
    background: #fef4ef;
    padding: 0.5rem 1rem 1rem;
    border-radius: 1rem;
    backdrop-filter: blur(0.875rem) saturate(160%);
    border: 1px solid rgba(255, 255, 255, 0.4);
    box-shadow: 0 0.5rem 24px rgba(0, 0, 0, 0.08), inset 0 1px 2px rgba(255, 255, 255, 0.4); /* depth + glow */

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 0;
    }
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 0;
    }
`

export const NewsLetterWrapper = styled.div`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        padding: 4rem 1rem;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        padding: 1rem 11.625rem 2rem;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        max-width: 44.5rem;
        padding: 1rem 0 2rem;
    }
`

export const ImageContainer = styled.div`
    width: 4.5rem;
    height: 4.5rem;
    margin: 1rem 0;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        width: 7rem;
        height: 7rem;
    }
`

export const NewsLetterHeading = styled.span(
    ({ theme }) => css`
        font-family: ${theme.typography.font.family.lato};
        font-weight: 600;
        font-size: 1.25rem;
        line-height: 1.75rem;
        text-align: center;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            font-size: 2.25rem;
            line-height: 2.625rem;
            text-align: left;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            font-size: 2rem;
            line-height: 2.5rem;
        }
    `,
)

export const NewsLetterSubheading = styled.span`
    font-family: ${props => props.theme.typography.font.family.lato};
    font-weight: 400;
    font-size: 0.875rem;
    line-height: 1.375rem;
    margin-top: 0.5rem;
    color: #5f5f5f;
    text-align: center;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        font-size: 1rem;
        line-height: 1.5rem;
    }
`
